document.addEventListener('DOMContentLoaded', function () {
  const openCustomerService = document.getElementsByClassName('title-block-wrapper');
  const optionCustomer = document.getElementsByClassName('content-footer-link');

  function isMobile() {
    return window.innerWidth <= 768;
  }

  // Gán toggle cho từng phần tử trong openCustomerService
  Array.from(openCustomerService).forEach((el, index) => {
    el.addEventListener('click', function () {
      if (!isMobile()) return;
      const panel = optionCustomer[index];
      if (panel) panel.classList.toggle('open');
    });
  });
});
